export default __webpack_public_path__ + "9f994c31252361cf401bee49cfb81d02.gif";